export default {
  translation: {
    "A scheduled task start date has already been assigned in some instance cards:":
      "Плановая дата начала задач уже назначена в карточке некоторых экземпляров:",
    "Access denied": "Доступ запрещен",
    "Action is irreversible": "Это действие необратимо",
    "Actual duration": "Длительность факт",
    "Actual start date": "Факт. дата начала",
    "Actual end date": "Факт. дата окончания",
    Add: "Добавить",
    "Add points": "Добавить точки",
    "Add version": "Добавить версию",
    "Adding points": "Добавление точек",
    Address: "Адрес",
    "Advanced settings": "Дополнительные настройки",
    all: "все",
    "All data will be deleted": "Все данные будут удалены",
    "Allow import from file": "Разрешить импорт из файла",
    "Appeal to technical support is registered":
      "Обращение в техподдержку зарегистрировано",
    Amount: "Количество",
    Apply: "Применить",
    "Are you sure to delete {{count}} persons?":
      "Удалить {{count}} пользователей?",
    "Are you sure to delete {{count}} persons?_one":
      "Удалить {{count}} пользователя?",
    "Are you sure to delete version?": "Вы уверены, что удаляете версию?",
    "Are you sure to delete selected positions?":
      "Вы уверены, что хотите удалить выбранные позиции?",
    "Assign a new one for the selected instances":
      "Назначить новую для выбранных экземпляров",
    "Attached file": "Вложенный файл",
    "Attached files": "Вложенные файлы",
    "Attention!": "Внимание!",
    Attributes: "Атрибуты",
    Attribute: "Атрибут",
    'Attributes to display the role "{{role}}"':
      'Атрибуты для отображения роли "{{role}}"',
    "Authorization required": "Требуется авторизация",
    "Base size": "Базовый размер",
    "By another attribute value": "По значению другого атрибута",
    "By another attribute value tooltip":
      "Список сужается по значению выбранного атрибута",
    "By references (referencing instances only)":
      "По ссылкам (только ссылающиеся экземпляры)",
    "By references tooltip":
      "Список сужается до экземпляров, ссылающихся на этот экземпляр по выбранному атрибуту",
    "Bussiness dictionaries": "Бизнес-справочники",
    "Calendar plan created": "Календарный план создан",
    Category: "Категория",
    Cancel: "Отменить",
    "Cannot select the current model to copy":
      "Невозможно выбрать текущую модель для копирования",
    Change: "Изменить",
    "Change of state": "Смена состояния",
    "Change password": "Изменение пароля",
    "Change state": "Изменить состояние",
    "Changing the value of attributes": "Изменение значения атрибутов",
    ChangingTheStateOfAnInstance_one: "Изменение состояния экземпляра",
    ChangingTheStateOfAnInstance_many: "Изменение состояния экземпляров",
    "Chat list": "Список чатов",
    "Checking whether instances have a calendar plan":
      "Проверка наличия календарного плана у экземпляров",
    Clear: "Очистить",
    "Click or drag the file/s to the area to upload. Downloading from the clipboard is possible.":
      "Нажмите или перетащите файл/ы в область для загрузки. Возможна загрузка из буфера обмена.",
    Close: "Закрыть",
    Color: "Цвет",
    "Color manual": "Руководство по цвету",
    "Color model": "Цветовая модель",
    "Color reference": "Пример цвета",
    "Collapse menu": "Свернуть меню",
    "Columns visibility": "Видимость столбцов",
    Comment: "Комментарий",
    "Communication between objects is not configured. Contact your administrator.":
      "Не настроена связь между объектами. Обратитесь к администратору.",
    "Confirm deletion": "Подтвердить удаление",
    "Confirm deletion of N instances":
      "Подтвердите удаление {{count}} экземпляров",
    "Confirm deletion of N instances_one":
      "Подтвердите удаление {{count}} экземпляра",
    "Contacting tech support": "Обращение в техподдержку",
    Continue: "Продолжить",
    "Continue to create a calendar plan?":
      "Продолжить создание календарного плана?",
    "Continue without instances": "Продолжить без экземпляров",
    Copy: "Копировать",
    "Copy to": "Копировать В",
    "Copy to another instance from current instance":
      "Копирование В другой экземпляр ИЗ текущего",
    "Copy from": "Копировать ИЗ",
    "Copy from model": "Копировать из модели",
    "Copy from template": "Копировать из шаблона",
    "Copy to another model": "Скопировать в другую модель",
    Copying: "Копирование",
    "Copying an instance": "Копирование экземпляра",
    "Copying was successful": "Копирование выполнено успешно",
    Count: "Количество",
    Country: "Страна",
    Create: "Создать",
    "Create a calendar plan": "Создать календарный план",
    "Create a chat": "Создать чат",
    "Create a task": "Создать задачу",
    "Create BOM": "Создать BOM",
    "Create empty matType": "Создать пустую позицию {{matType}}",
    "Create from template": "Создать из шаблона",
    "Create matType from library": "Создать позицию {{matType}} из справочника",
    "Create request": "Создать запрос",
    "Creating a calendar plan is not possible":
      "Создание календарного плана невозможно",
    "Creating BOM": "Создание BOM",
    "Creating matType from library":
      "Создание позиции {{matType}} из справочника",
    "Current password": "Текущий пароль",
    "Current state": "Текущее состояние",
    "Customizing the column display": "Настройка отображения колонок",
    Dashboards: "Дашборды",
    "Data not loaded": "Данные не загружены",
    "Data updated": "Выполнено обновление данных",
    "Data will be displayed after saving":
      "Данные отобразятся после сохранения",
    Date: "Дата",
    DateFormat: "DD.MM.YYYY",
    DateTimeFormat: "DD.MM.YYYY HH:mm",
    "Delay / override": "Задержка / опережение",
    Delete: "Удалить",
    "Delete chat": "Удалить чат",
    "Delete selected": "Удалить выбранное",
    "Delete version": "Удалить версию",
    "Deletion is impossible": "Удаление невозможно",
    "Deletion of tasks": "Удаление задач",
    "Deletion task": "Задача на удаление",
    "Describe the question": "Опишите вопрос",
    Description: "Описание",
    Dictionaries: "Справочники",
    "Display available only for created instances":
      "Отображение доступно только для созданных экземпляров",
    Division: "Подразделение",
    "Disable entity versioning": "Отключить версионирование экземпляров",
    "Do you really want to delete the chat ?":
      "Вы действительно хотите удалить чат",
    "Do you really want to delete the selected instances?":
      "Вы действительно хотите удалить выбранные экземпляры?",
    "Do you want to delete the current entry?":
      "Выполнить удаление текущей записи?",
    "Doesn't match": "Не совпадает",
    "Do you want to delete the selected records?":
      "Выполнить удаление выделенных записей?",
    Done: "Готово",
    "Download template": "Скачать шаблон",
    Edit: "Редактировать",
    "Enter a name": "Введите имя",
    "Enter email": "Введите email",
    "Enter the Email you used when registering your account":
      "Введите Email, который вы использовали при регистрации учетной записи. Мы отправим вам ссылку для восстановления пароля.",
    "Enter information to register on the platform":
      "Внесите данные для регистрации на платформе",
    "EntityId value not received": "Не получено значение entityId",
    // Пустое значение строки, апперкейс приходит с бэкенда
    EMPTY_VALUE_STRING_WORD: "Пустое значение",
    Entity_one: "Сущность",
    Entity_few: "Сущности",
    Error: "Ошибка",
    "Error when accessing the server": "Ошибка при обращении к серверу",
    "Estimated start date": "Расчетная дата начала",
    "Estimated end date": "Расчетная дата окончания",
    "Executed instance creation": "Выполнено создание экземпляра",
    File: "Файл",
    "File modification": "Изменение файлов",
    "Fill in attribute {name}": `Заполнить атрибут "{{name}}"`,
    "File upload error": "Ошибка загрузки файла",
    "File processing may take a long time":
      "Обработка файла может занять длительное время. По окончании обработки вы получите пуш-уведомление в системе",
    Filter: "Фильтр",
    "Find an attribute": "Найти атрибут",
    Finish: "Завершить",
    "Format: value": "Формат: {{value}}",
    From: "От",
    "From the template": "Из шаблона",
    "Full name": "Ф.И.О.",
    "General information": "Общая информация",
    "Groups and roles": "Группы и роли",
    Heading: "Название",
    "Hierarchy structure": "Структура иерархии",
    "History of changes": "История изменений",
    Image: "Изображение",
    "Image modification": "Изменение изображений",
    Import: "Импортировать",
    "Import from file": "Импорт из файла",
    "Import from file is running": "Запущен импорт из файла",
    "Import from file will be available again after the current import is completed":
      "Импорт из файла будет снова доступен после завершения текущего импорта",
    "Incorrect current password": "Указан неверный текущий пароль",
    "Incorrect format of received data": "Ошибочный формат полученных данных",
    "Instance of object": "Экземпляр объекта {{name}}",
    "Instructions for working in the system": "Инструкция по работе в системе",
    "Invalid email format": "Неверный формат email",
    "Invalid data format:": "Неверный формат данных для {{file}}",
    "Invalid page URL": "Неверный URL-адрес страницы",
    "Invalid row id in version key":
      "Неверный идентификатор строки в ключе версии: {{key}}",
    "Invalid version key": "Неверный ключ версии: {{key}}",
    "Is not selected": "{{parameter}} не выбран",
    "It is required to correctly fill in the fields on the form":
      "Требуется правильно заполнить поля на форме",
    "Keep the current one": "Оставить текущую",
    "Letter has been sent": "Письмо отправлено",
    "Limit instance list selection:": "Ограничить выбор в списке экземпляров:",
    Link: "Ссылка",
    Loading: "Загрузка",
    Location: "Расположение",
    Login: "Вход",
    Logout: "Выйти",
    Members: "Участники",
    Message: "Сообщение",
    Main: "Главное",
    "Main title": "Главная",
    Management: "Управление",
    "Mark everything as read": "Отметить всё прочитанным",
    "Marked by reading": "Отметить прочитанным",
    massCreatePlans: "Массовое создание задач из шаблона",
    Material: "Материал",
    "Material Type": "Тип материала",
    "Maximum number: count": "Максимальное количество: {{count}}",
    "Maximum total size:": "Максимальный общий размер: {{size}} Мб",
    "Menu settings": "Настройка меню",
    "Missing value": "Отсутствует значение {{parameter}}",
    Model: "Модель",
    Models: "Модели",
    Modify: "Изменить",
    "N items deleted": "Удалено {{count}} экземпляров",
    "N items deleted_one": "Удалён {{count}} экземпляр",
    "N items deleted_few": "Удалено {{count}} экземпляра",
    Name: "Имя",
    "New instance": "Новый экземпляр",
    "New instance has been created": "Создан новый экземпляр",
    "New instance of object": "Новый экземпляр объекта {{name}}",
    "New instances were created": "Создано {{count}} новых экземпляров",
    "New instances were created_one": "Создан {{count}} новый экземпляр",
    "New instances were created_few": "Создано {{count}} новых экземпляра",
    "New password": "Новый пароль",
    "New position": "Новая позиция",
    "New task": "Новая задача",
    Next: "Далее",
    No: "Нет",
    "No available states for transition":
      "Нет доступных состояний для перехода",
    "No match for path {path}": "Нет соответствия пути {path}",
    "No selected points to copy": "Нет выбранных точек для копирования",
    "No object specified": "Не указан объект",
    "No records selected for copying": "Не выбраны записи для копирования",
    Notifications: "Уведомления",
    "Number of hidden columns": "Количество скрытых колонок: {{count}}",
    Object: "Объект",
    "Objects and attributes": "Объекты и атрибуты",
    OK: "ОК",
    Or: "Или",
    Overwrite: "Перезаписать",
    "Overwrite measurement chart changes?":
      "Перезаписать изменения Measurement chart?",
    Password: "Пароль",
    "Password change completed": "Выполнена смена пароля",
    "Password must contain": "Пароль должен содержать",
    "Password recovery": "Восстановление пароля",
    Performer: "Исполнитель",
    "Performer load per task per day": "Загрузка исполнителя на задачу в день",
    Persons: "Пользователи",
    Plan: "План",
    "Plan template": "Шаблон плана",
    "Planned duration": "Длительность план",
    "Planned start date": "Плановая дата начала",
    "Planned end date": "Плановая дата окончания",
    "Please, select a source model and click the Copy button.":
      "Пожалуйста, выберите исходную модель и нажмите кнопку Копировать..",
    "Please, select a template instance and click the Copy button.":
      "Выберите экземпляр шаблона и нажмите кнопку Копировать.",
    "Point name": "Название точки",
    Positions: "Позиции",
    "Press Ctrl+Enter/Cmd+Enter to apply":
      "Нажмите Ctrl+Enter/Cmd+Enter, чтобы применить",
    "Previous step": "Предыдущий шаг",
    "Previous task": "Предыдущая задача",
    Priority: "Приоритет",
    "Product article": "Артикул",
    "Quality details": "Детали",
    Question: "Вопрос",
    "Recalculation of planned dates for tasks":
      "Пересчет плановых дат для задач",
    "Reference is empty": "{{object}} reference is empty",
    Refresh: "Обновить",
    Register: "Зарегистрироваться",
    "Registration of object": 'Регистрация объекта "{{obj}}"',
    "Related tasks": "Связанные задачи",
    Repeat: "Повторить",
    "Repeat new password": "Повтор нового пароля",
    Reset: "Сбросить",
    "Restore password": "Восстановить пароль",
    "Return to the authorization page": "Вернуться на страницу авторизации",
    Save: "Сохранить",
    "Saving is not possible. Status: {{status}}":
      "Сохранение невозможно. Статус: {{status}}",
    Scale: "Скейлинг",
    "Scaling will change the dimension values relative to the base size.":
      "При скейлинге значения размеров изменяются относительно базового размера.",
    Search: "Поиск",
    "Search by name or description": "Поиск по имени или описанию",
    Send: "Отправить",
    "Send link": "Отправить ссылку",
    "Server error": "Ошибка сервера",
    Setting: "Настройки",
    Select: "Выбрать",
    "Select an instance to copy previously selected instances":
      "Выберите экземпляр для копирования выбранных ранее экземпляров",
    "Select dependent objects to copy":
      "Выберите зависимые объекты для копирования:",
    "Selected positions": "Выбранные позиции",
    "Select positions to copy": "Выберите позиции для копирования",
    "Select the desired menu item to start operation":
      "Выберите нужный пункт в меню для начала работы",
    "Select the instance to copy": "Выберите экземпляр для копирования",
    "Select the instances to copy": "Выберите экземпляры для копирования",
    "Select the instances to copy previously selected instances":
      "Выберите экземпляр для копирования выбранных ранее экземпляров",
    "Select the instance to which you want to copy the previously selected instances of the linked object with all relationships":
      "Выберите экземпляр, в который необходимо скопировать ранее выбранные экземпляры связанного объекта со всеми связями",
    "Select the instances where to move the copied instances to":
      "Выберите экземпляры куда перенести скопированные экземпляры",
    "Select the source instance to copy":
      "Выберите экземпляр-источник для копирования",
    Selected: "Выбрано",
    "Select all states": "Выбрать все",
    "Selected states count": "Выбрано: {{count}}",
    "Unavailable state": "Недоступное состояние: {{id}}",
    "Selected lines count": "Выбрано {{count}} строк",
    "Selected lines count_one": "Выбрана {{count}} строка",
    "Selected lines count_few": "Выбрано {{count}} строки",
    "Selecting a plan template": "Выбор шаблона плана",
    "Selecting a point": "Выбор точки",
    "Selecting a task group template": "Выбор шаблона группы задач",
    "Selecting a task template": "Выбор шаблона задачи",
    "Send message": "Отправить сообщение",
    "Send registration request": "Отправить запрос на регистрацию",
    "Set default view": "Установить вид по умолчанию",
    "Short name": "Краткое название",
    "Sign In": "Войти",
    Size: "Размер",
    "Size line": "Размерный ряд",
    "Size scale": "Размерный ряд",
    "Show filter": "Показывать фильтр",
    "Show for the period": "Показать за период",
    "Show Gantt": "Показать Гант",
    "Specify the topic": "Укажите тему",
    "SSO Authorization": "Авторизация через SSO",
    State: "Состояние",
    "State change performed": "Выполнено изменение состояния",
    Status: "Статус",
    Step: "Шаг {{count}}",
    Subject: "Тема",
    Submit: "Отправить",
    Summary: "Сводка",
    Supplier: "Поставщик",
    "System is not ready": "Система не готова",
    "Table export": " Экспорт таблицы",
    Task: "Задача",
    "Task bindings associated with the task(s) have been deleted. Scheduled start and end dates of tasks recalculated.":
      "Связанные с задачей(-ми) привязки задач удалены. Плановые даты начала и окончания задач пересчитаны.",
    "Task deletion completed": "Удаление задач выполнено",
    "Task deletion completed_one": "Удаление задачи выполнено",
    "Task group": "Группа задач",
    "Task group / task": "Группа задач / задача",
    "Task group template": "Шаблон группы задач",
    "Task related task bindings have been removed":
      "Связанные с задачами привязки задач удалены",
    "Task related task bindings have been removed_one":
      "Связанные с задачей привязки задач удалены",
    "Tasks have been deleted.": "Задачи были удалены.",
    "Task has been deleted.": "Задача “{{name}}” удалена.",
    "Task is completed": 'Задача "{{name}}" завершена!',
    "Task is in progress": 'Задача "{{name}}" в работе!',
    "Tasks selected for deletion": "Выбрано задач на удаление",
    "Task template": "Шаблон задачи",
    "Task was not found": 'Задача "{{name}}" не найдена!',
    "Task without template": "Задача без шаблона",
    "Tech support": "Техподдержка",
    templates: "шаблоны",
    "The attributes are mandatory when transitioning to this state":
      "Атрибуты {{attrs}} обязательны для заполнения при переходе в это состояние",
    "The calendar of these instances has already been created and contains tasks":
      "Календарный план данных экземпляров уже создан и содержит задачи",
    "The calendar plan cannot be created in some instances because it has already been created and contains tasks":
      "Календарный план не может быть создан в некоторых экземплярах, так как уже создан и содержит задачи",
    "The deletion will affect scheduled task dates, due to the deletion of task bindings.":
      "Удаление повлияет на плановые даты задач, в связи с удалением привязок задач.",
    "The field is mandatory": "Поле является обязательным",
    "The form contains unsaved data. Continue with data loss?":
      "Форма содержит несохранённые данные. Продолжить с потерей данных?",
    "The instance is missing": "Экземпляр отсутствует",
    "The instances have been deleted": "Экземпляры были удалены",
    "The link must start with":
      "Ссылка должна начинаться с http:// или https://",
    "The measurement chart points has been copied successfully":
      "Точки из Measurement chart успешно скопированы",
    "The message contains an attachment": "Сообщение содержит вложение",
    "The state has been deleted": "Состояние было удалено",
    "The selected tasks contain tasks in the “In Progress” and/or “Completed” status!":
      "Выбранные задачи содержат задачи в состоянии «В работе» и/или «Завершенные»!",
    "The service has not been configured": "Не выполнена настройка сервиса",
    "The dictionary must contain at least one entry":
      "Словарь {{dict}} должен содержать хотя бы одну запись",
    "There are no messages in the chat": "Cообщения в чате отсутствуют",
    "There is no user with the specified data":
      "Нет пользователя с указанными данными",
    "This file format is not supported":
      "Данный формат файла не поддерживается",
    TimeFormat: "HH:mm:ss",
    To: "До",
    "To home": "На главную",
    Total: "Итого",
    "Total files size exceeds": "Общий размер файлов превышает {{size}} Мб",
    "Total models: {{count}}": "Всего моделей: {{count}}",
    "Total information": "Суммарная информация",
    "Total instances count": "Всего экземпляров: {{count}}",
    "Total persons count": "Всего {{count}} пользователей",
    "Total persons count_one": "Всего {{count}} пользователь",
    "Total persons count_few": "Всего {{count}} пользователя",
    "Trim size": "Размер",
    "Value cleared": "Значение очищено",
    Upload: "Загрузить",
    "Upload a file": "Прикрепить файл",
    User: "Пользователь",
    UserAccount: "Личный кабинет",
    Yes: "Да",
    "You cannot delete a task.": "Удаление задачи невозможно.",
    "You cannot delete tasks. Select tasks in the “Created” state.":
      "Удаление задач невозможно. Выберите задачи в состоянии «Создана».",
    "Your request has been registered by the technical support service":
      "Ваше обращение зарегистрировано службой технической поддержки",
    "Wait until saving finishes": "Дождитесь завершения сохранения",
    "Welcome to the Omnidata platform!":
      "Добро пожаловать на платформу Omnidata!",
    "When saving, multiple instances of the object will be created":
      'При сохранении будет создано несколько экземпляров объекта "{{obj}}", по одному на каждое выбранное значение атрибута "{{attr}}"',

    actionType: {
      // see ActionTypeName
      ATTRIBUTE: "Атрибут",
      OBJECT: "Объект",
      ENTITY: "Экземпляр",
    },
    attrType: {
      ARTICLE: "Артикул",
      BOOLEAN: "Логическое значение",
      CHILD_OBJECT_ID: "Список зависимых объектов",
      DATE: "Дата",
      DATE_WITH_TIME: "Дата и время",
      OBJECT_ID: "Ссылка на другой объект",
      ONE_CHOICE_DICTIONARY: "Справочник",
      FILE: "Файл",
      FINANCIAL: "Финансовый",
      FORMULA: "Формула",
      IMAGE: "Изображение",
      INT: "Целое число",
      LINK_TO_EXTERNAL_SOURCE: "Ссылка на внешний ресурс",
      LINKED_VALUE: "Отображение по ссылке",
      MULTIPLE_CHOICE_DICTIONARY: "Множественный выбор из справочника",
      NUMERIC: "Дробное число",
      STRING: "Текст",
      SYSTEM_LANGUAGE: "Язык системы",
      TIME: "Время",
      USER_FILTER: "Список пользователей",
    },
    groupType: {
      ByDictionary: "На основе справочника",
      Mnemonic: "Мнемоническая",
      Dictionary: "Справочник",
    },
    management: {
      AddGroup: "Добавить группу",
      "Confirm deletion of dictionary group":
        "Вы действительно хотите удалить группу справочников?",
      "Confirm deletion of dictionary":
        "Вы действительно хотите удалить справочник?",
      "Deleting a dictionary group": "Удаление группы справочников",
      "Group name": "Название группы",
      "New group of dictionaries": "Новая группа справочников",
      "Wrong group type": "Неверный формат группы",
    },
    Month3: {
      Jan: "Янв",
      Feb: "Фев",
      Mar: "Мар",
      Apr: "Апр",
      May: "Май",
      Jun: "Июн",
      Jul: "Июл",
      Aug: "Авг",
      Sep: "Сен",
      Oct: "Окт",
      Nov: "Ноя",
      Dec: "Дек",
    },
    Pages: {
      Plans: "Планы",
      Projects: "Проекты",
      Reports: "Отчёты",
    },
    PasswordProps: {
      "at least N characters": "не менее {{count}} символов",
      "contain numbers": "содержать цифры {{n}}",
      "uppercase Latin letters": "прописные латинские буквы {{n}}",
      "lowercase Latin letters": "строчные латинские буквы {{n}}",
      "special characters": "специальные символы",
      "password cannot be the same as login":
        "пароль не может совпадать с логином",
      "Not done": "Не выполнено: {{n}}",
    },
    vaidation: {
      required: "Поле обязательно для заполнения",
    },
  },
};
